(() => {
  const resetTimers = new WeakMap();

  const copyText = async (value) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return;
    }

    const field = document.createElement('textarea');
    field.value = value;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    const copied = document.execCommand('copy');
    field.remove();
    if (!copied) throw new Error('Copy command failed');
  };

  const announce = (button, label) => {
    const labelElement = button.querySelector('[data-cobd-action-label]');
    if (!labelElement) return;

    labelElement.textContent = label;
    window.clearTimeout(resetTimers.get(button));
    resetTimers.set(button, window.setTimeout(() => {
      labelElement.textContent = button.dataset.label || label;
    }, 2200));
  };

  const openJumpTarget = (event, link) => {
    const selector = link.getAttribute('href');
    if (!selector || selector.charAt(0) !== '#') return;
    const target = document.querySelector(selector);
    if (!target) return;

    event.preventDefault();
    const disclosure = target.matches('details') ? target : target.querySelector('details');
    if (disclosure) disclosure.open = true;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    const targetUrl = new URL(window.location.href);
    targetUrl.hash = selector;
    window.history.replaceState(null, '', targetUrl);
  };

  const removePrintSheet = () => {
    document.querySelectorAll('body > .cobd-print-sheet--active').forEach((sheet) => sheet.remove());
    document.body.classList.remove('cobd-printing');
  };

  document.addEventListener('click', async (event) => {
    const copyButton = event.target.closest('[data-cobd-copy-sku]');
    if (copyButton) {
      const value = copyButton.closest('.product-sku')?.querySelector('.product-sku__value')?.textContent?.trim();
      if (!value) return;
      try {
        await copyText(value);
        announce(copyButton, copyButton.dataset.successLabel || 'SKU copied');
      } catch (error) {
        announce(copyButton, copyButton.dataset.errorLabel || 'Copy failed');
      }
      return;
    }

    const shareButton = event.target.closest('[data-cobd-share]');
    if (shareButton) {
      const currentUrl = new URL(window.location.href);
      currentUrl.hash = '';
      const shareData = {
        title: shareButton.dataset.title || document.title,
        url: currentUrl.href || shareButton.dataset.url
      };
      try {
        if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
          await navigator.share(shareData);
        } else {
          await copyText(shareData.url);
          announce(shareButton, shareButton.dataset.successLabel || 'Product link copied');
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          announce(shareButton, shareButton.dataset.errorLabel || 'Copy link failed');
        }
      }
      return;
    }

    const printButton = event.target.closest('[data-cobd-print]');
    if (printButton) {
      const template = document.getElementById(printButton.dataset.printTemplate);
      if (!template) return;
      removePrintSheet();
      document.body.appendChild(template.content.cloneNode(true));
      document.body.classList.add('cobd-printing');
      const printSheet = document.querySelector('body > .cobd-print-sheet--active');
      const printImage = printSheet?.querySelector('img');
      let printStarted = false;
      const startPrint = () => {
        if (printStarted) return;
        printStarted = true;
        window.print();
      };

      if (printImage && !printImage.complete) {
        printImage.addEventListener('load', startPrint, { once: true });
        printImage.addEventListener('error', startPrint, { once: true });
        window.setTimeout(startPrint, 900);
      } else {
        window.setTimeout(startPrint, 50);
      }
      return;
    }

    const jumpLink = event.target.closest('[data-cobd-jump-link]');
    if (jumpLink) openJumpTarget(event, jumpLink);
  });

  document.addEventListener('on:variant:change', (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;

    document.querySelectorAll('[data-cobd-print-template]').forEach((template) => {
      const sku = template.content.querySelector('[data-cobd-print-sku]');
      if (sku) sku.textContent = variant.sku || 'Not supplied';

      (variant.options || []).forEach((value, index) => {
        const cell = template.content.querySelector(`[data-cobd-print-option="${index}"]`);
        if (cell) cell.textContent = value;
      });

      const image = template.content.querySelector('.cobd-print-sheet__image');
      const imageSource = variant.featured_media?.preview_image?.src;
      if (image && imageSource) {
        image.src = imageSource;
        image.removeAttribute('srcset');
      }
    });
  });

  window.addEventListener('afterprint', removePrintSheet);
})();
